<div class="header">
    <div class="row">
        <div class="col-6 detail-header-left">
            <h2>Dettaglio <strong>Cliente</strong></h2>
            <div class="detail-header-actions">
                <a [routerLink]="['/clienti/modifica/' + customer.IDCustomer]" class="btn btn-xs btn-primary detail-action-btn"><i class="fa fa-pencil"></i><span>Modifica</span></a>
                <a *ngIf="customer.Enabled" (click)="openToggleEnabledModal()" class="btn btn-xs btn-warning detail-action-btn"><i class="fa fa-ban"></i><span>Disabilita</span></a>
                <a *ngIf="!customer.Enabled" (click)="openToggleEnabledModal()" class="btn btn-xs btn-success detail-action-btn"><i class="fa fa-check"></i><span>Riattiva</span></a>
            </div>
        </div>
        <div class="col-4" style="text-align: right; margin-top: 10px;">
            <ol class="breadcrumb">
                <li><a style="cursor: pointer;" [routerLink]="['/clienti']">Clienti</a></li>
                <li class="active">Dettaglio Cliente</li>
            </ol>
        </div>
    </div>
</div>
<div class="row">
    <div class="col-md-5 col-12">
        <div class="panel">
            <div class="panel-header panel-controls bg-dark">
                <h3><i class="fa fa-list"></i>Dati <strong>Società / Ditta Individuale</strong></h3>
            </div>
            <div class="panel-content detail-panel">
                <div class="detail-section">
                    <div class="detail-section-title">Anagrafica</div>
                    <div class="detail-field">
                        <span class="detail-label">Stato</span>
                        <span class="detail-value">
                            <span *ngIf="customer.Enabled" class="badge badge-success">Attivo</span>
                            <span *ngIf="!customer.Enabled" class="badge badge-secondary">Disabilitato</span>
                        </span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">Data Creazione</span>
                        <span class="detail-value">{{ customer.CreationDate ? (customer.CreationDate | date: 'dd/MM/yyyy HH:mm') : '-' }}</span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">Ragione Sociale</span>
                        <span class="detail-value">{{ displayValue(customer.CompanyName) }}</span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">Forma Giuridica</span>
                        <span class="detail-value">{{ displayValue(customer.LegalForm) }}</span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">Partita IVA</span>
                        <span class="detail-value">{{ displayValue(customer.VATNumber) }}</span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">Codice Fiscale</span>
                        <span class="detail-value">{{ displayValue(customer.FiscalCode) }}</span>
                    </div>
                </div>

                <div class="detail-section">
                    <div class="detail-section-title">Registro Imprese e Visura</div>
                    <div class="detail-field">
                        <span class="detail-label">Camera di Commercio</span>
                        <span class="detail-value">{{ displayValue(customer.ChamberOfCommerce) }}</span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">Numero REA</span>
                        <span class="detail-value">{{ displayValue(customer.REANumber) }}</span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">Codice ATECO</span>
                        <span class="detail-value">{{ displayValue(customer.AtecoCode) }}</span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">Data Iscrizione</span>
                        <span class="detail-value">{{ customer.RegistrationDate ? (customer.RegistrationDate | date: 'dd/MM/yyyy') : '-' }}</span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">Data Visura</span>
                        <span class="detail-value">{{ customer.VisuraDate ? (customer.VisuraDate | date: 'dd/MM/yyyy') : '-' }}</span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">Addetti</span>
                        <span class="detail-value">{{ displayValue(customer.Employees) }}</span>
                    </div>
                </div>

                <div class="detail-section">
                    <div class="detail-section-title">Sede Legale</div>
                    <div class="detail-field">
                        <span class="detail-label">Sede Legale</span>
                        <span class="detail-value">{{ displayPlace(customer.HeadOffice, customer.HeadOfficeProvince) }}</span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">Via e Civico</span>
                        <span class="detail-value">{{ customerAddressDisplay }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-md-5 col-12">
        <div class="panel">
            <div class="panel-header panel-controls bg-dark">
                <h3><i class="fa fa-list"></i>Dati <strong>Legale Rappresentante e Contatti</strong></h3>
            </div>
            <div class="panel-content detail-panel">
                <div class="detail-section">
                    <div class="detail-section-title">Anagrafica Legale Rappresentante</div>
                    <div class="detail-field">
                        <span class="detail-label">Nome</span>
                        <span class="detail-value">{{ displayValue(customer.Name) }}</span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">Cognome</span>
                        <span class="detail-value">{{ displayValue(customer.Surname) }}</span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">Luogo di Nascita</span>
                        <span class="detail-value">{{ displayPlace(customer.BirthPlace, customer.BirthPlaceProvince) }}</span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">Data di Nascita</span>
                        <span class="detail-value">{{ customer.BirthDate ? (customer.BirthDate | date: 'dd/MM/yyyy') : '-' }}</span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">Comune di Residenza</span>
                        <span class="detail-value">{{ displayPlace(customer.City, customer.Province) }}</span>
                    </div>
                </div>

                <div class="detail-section">
                    <div class="detail-section-title">Contatti</div>
                    <div class="detail-field">
                        <span class="detail-label">Email</span>
                        <span class="detail-value">
                            <ng-container *ngIf="emailList.length; else noCustomerEmail">
                                <span class="detail-email" *ngFor="let email of emailList">{{ email }}</span>
                            </ng-container>
                            <ng-template #noCustomerEmail>-</ng-template>
                        </span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">Domicilio Digitale (PEC)</span>
                        <span class="detail-value">{{ displayValue(customer.PEC) }}</span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">Telefono Fisso</span>
                        <span class="detail-value">{{ displayValue(customer.Phone) }}</span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">Telefono Cellulare</span>
                        <span class="detail-value">{{ displayValue(customer.MobilePhone) }}</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="panel">
            <div class="panel-header panel-controls bg-dark">
                <h3><i class="fa fa-list"></i>Dati <strong>Banca, Fatturazione e Bilancio</strong></h3>
            </div>
            <div class="panel-content detail-panel">
                <div class="detail-section">
                    <div class="detail-section-title">Banca e Fatturazione</div>
                    <div class="detail-field">
                        <span class="detail-label">IBAN</span>
                        <span class="detail-value">{{ displayValue(customer.IBAN) }}</span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">Banca di Appoggio</span>
                        <span class="detail-value">{{ displayValue(customer.SupportBankName) }}</span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">BIC Banca di Appoggio</span>
                        <span class="detail-value">{{ displayValue(customer.SupportBankBIC) }}</span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">Codice SDI</span>
                        <span class="detail-value">{{ displayValue(customer.SDICode) }}</span>
                    </div>
                </div>

                <div class="detail-section">
                    <div class="detail-section-title">Ultimo Bilancio</div>
                    <div class="detail-field">
                        <span class="detail-label">Data Bilancio</span>
                        <span class="detail-value">{{ customer.BalanceDate ? (customer.BalanceDate | date: 'dd/MM/yyyy') : '-' }}</span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">ULA Ultimo Bilancio</span>
                        <span class="detail-value">{{ displayValue(customer.ULALastBalance) }}</span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">Ricavi Vendite e Prestazioni</span>
                        <span class="detail-value">{{ displayValue(customer.SalesRevenues) }}</span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">Totale Attivo</span>
                        <span class="detail-value">{{ displayValue(customer.TotalAssets) }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="row">
    <div class="col-md-10 col-12">
        <div class="panel">
            <div class="panel-header panel-controls bg-dark">
                <h3><i class="fa fa-file"></i> <strong>Documentazione</strong></h3>
            </div>
            <div class="panel-content">
                <div class="table-scroll">
                    <table *ngIf="documents.length > 0" class="table table-hover table-historical">
                        <thead>
                        <tr>
                            <th>Nome File</th>
                            <th>Tipologia</th>
                            <th class="text-right col-sticky col-sticky-actions">Azioni</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr *ngFor="let currentDocument of documents">
                            <td>{{ currentDocument.Path }}</td>
                            <td>{{ getDocumentTypeLabel(currentDocument.FKIDDocumentType) }}</td>
                            <td class="text-right col-sticky col-sticky-actions">
                                <a (click)="previewDocument(currentDocument)" class="edit btn btn-sm doc-preview-btn" title="Anteprima" aria-label="Anteprima"><i class="fa fa-eye"></i></a>
                                <a (click)="downloadDocument(currentDocument)" class="edit btn btn-sm btn-success" title="Download" aria-label="Download"><i class="fa fa-download"></i></a>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div *ngIf="documents.length === 0" class="detail-empty-state">
                    Nessun documento caricato.
                </div>
            </div>
        </div>
    </div>
</div>
<div class="row">
    <div class="col-md-10 col-12" style="margin-bottom: 100px;">
        <div class="panel">
            <div class="panel-header panel-controls bg-dark">
                <h3><i class="fa fa-list"></i>Pratiche <strong>Collegate</strong></h3>
            </div>
            <div class="panel-content">
                <div *ngIf="linkedRequests.length > 0; else noLinkedRequests" class="table-container table-scroll">
                    <table class="table table-hover table-customer">
                        <thead>
                        <tr>
                            <th>ID Pratica</th>
                            <th>Data Creazione</th>
                            <th>Ragione Sociale</th>
                            <th>Tipologia</th>
                            <th>Email</th>
                            <th>Cellulare</th>
                            <th>Stato</th>
                            <th>DNS completata</th>
                            <th>Iper 4.0 completato</th>
                            <th class="text-right col-sticky col-sticky-actions">Azioni</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr *ngFor="let request of linkedRequests">
                            <td (click)="goToRequestDetail(request.IDRequest)">{{ request.IDRequest }}</td>
                            <td (click)="goToRequestDetail(request.IDRequest)">{{ request.CreationDate ? (request.CreationDate | date: 'dd/MM/yyyy HH:mm') : '-' }}</td>

                            <td *ngIf="customer.CompanyName !== ''" (click)="goToRequestDetail(request.IDRequest)">{{ customer.CompanyName }}</td>
                            <td *ngIf="customer.CompanyName === ''" (click)="goToRequestDetail(request.IDRequest)" [innerHTML]="'<i>Da Compilare</i>'"></td>

                            <td (click)="goToRequestDetail(request.IDRequest)">{{ request.request_type.RequestType }}</td>
                            <td (click)="goToRequestDetail(request.IDRequest)">{{ request.Email }}</td>

                            <td *ngIf="customer.MobilePhone !== ''" (click)="goToRequestDetail(request.IDRequest)">{{ customer.MobilePhone }}</td>
                            <td *ngIf="customer.MobilePhone === ''" (click)="goToRequestDetail(request.IDRequest)" [innerHTML]="'<i>Da Compilare</i>'"></td>

                            <td *ngIf="request.ProgressStatus < 9" (click)="goToRequestDetail(request.IDRequest)"><span style="font-size: 13px;" class="badge badge-primary">In fase di compilazione</span></td>
                            <td *ngIf="request.ProgressStatus === 9 && !request.CompanyParticipation && !request.PartnersParticipation" (click)="goToRequestDetail(request.IDRequest)"><span style="font-size: 13px;" class="badge badge-info">Da convalidare</span></td>
                            <td *ngIf="request.ProgressStatus === 9 && (request.CompanyParticipation || request.PartnersParticipation)" (click)="goToRequestDetail(request.IDRequest)"><span style="font-size: 13px;" class="badge badge-warning">Da controllare</span></td>
                            <td *ngIf="request.ProgressStatus === 10" (click)="goToRequestDetail(request.IDRequest)"><span style="font-size: 13px;" class="badge badge-success">Completato</span></td>

                            <td class="completion-status-cell" (click)="goToRequestDetail(request.IDRequest)">
                                <span *ngIf="request.FKIDRequestType === 6"
                                      class="completion-status-indicator"
                                      [class.completion-status-indicator--done]="request.DNSCompleted"
                                      [class.completion-status-indicator--pending]="!request.DNSCompleted"
                                      [attr.aria-label]="request.DNSCompleted ? 'DNS completato' : 'DNS non completato'">
                                    <svg *ngIf="request.DNSCompleted" class="completion-status-svg" viewBox="0 0 16 16" aria-hidden="true" focusable="false">
                                        <path d="M3.25 8.25 L6.5 11.5 L12.75 4.75" fill="none" stroke="currentColor" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                    <svg *ngIf="!request.DNSCompleted" class="completion-status-svg" viewBox="0 0 16 16" aria-hidden="true" focusable="false">
                                        <path d="M4.25 4.25 L11.75 11.75 M11.75 4.25 L4.25 11.75" fill="none" stroke="currentColor" stroke-width="2.25" stroke-linecap="round"/>
                                    </svg>
                                </span>
                                <span *ngIf="request.FKIDRequestType !== 6">-</span>
                            </td>
                            <td class="completion-status-cell" (click)="goToRequestDetail(request.IDRequest)">
                                <span *ngIf="request.FKIDRequestType === 6"
                                      class="completion-status-indicator"
                                      [class.completion-status-indicator--done]="request.Iper4Completed"
                                      [class.completion-status-indicator--pending]="!request.Iper4Completed"
                                      [attr.aria-label]="request.Iper4Completed ? 'Iper 4.0 completato' : 'Iper 4.0 non completato'">
                                    <svg *ngIf="request.Iper4Completed" class="completion-status-svg" viewBox="0 0 16 16" aria-hidden="true" focusable="false">
                                        <path d="M3.25 8.25 L6.5 11.5 L12.75 4.75" fill="none" stroke="currentColor" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                    <svg *ngIf="!request.Iper4Completed" class="completion-status-svg" viewBox="0 0 16 16" aria-hidden="true" focusable="false">
                                        <path d="M4.25 4.25 L11.75 11.75 M11.75 4.25 L4.25 11.75" fill="none" stroke="currentColor" stroke-width="2.25" stroke-linecap="round"/>
                                    </svg>
                                </span>
                                <span *ngIf="request.FKIDRequestType !== 6">-</span>
                            </td>

                            <td class="text-right col-sticky col-sticky-actions">
                                <div ngbDropdown
                                     [autoClose]="'outside'"
                                     container="body"
                                     placement="bottom-right"
                                     class="btn-group">
                                    <button type="button" class="btn btn-secondary btn-sm dropdown-toggle" ngbDropdownToggle aria-haspopup="true" aria-expanded="false">
                                        Azioni
                                    </button>
                                    <div ngbDropdownMenu class="dropdown-menu dropdown-menu-right row-actions-menu">
                                        <button *ngIf="request.ProgressStatus === 9 && user.FKIDUserRole === 1" (click)="openCompleteRequestModal(request)" class="dropdown-item" type="button"><i class="fa fa-check"></i>Completa</button>
                                        <button *ngIf="request.ProgressStatus === 10 && user.FKIDUserRole === 1" (click)="openUncompleteRequestModal(request)" class="dropdown-item" type="button"><i class="fa fa-times"></i>Annulla</button>
                                        <button *ngIf="request.FKIDRequestType === 6 && !request.DNSCompleted" (click)="openCompleteDnsModal(request)" class="dropdown-item" type="button"><i class="fa fa-check"></i>Completa DNS</button>
                                        <button *ngIf="request.FKIDRequestType === 6 && request.DNSCompleted" (click)="openUncompleteDnsModal(request)" class="dropdown-item" type="button"><i class="fa fa-undo"></i>Annulla completamento DNS</button>
                                        <button *ngIf="request.FKIDRequestType === 6 && !request.Iper4Completed" (click)="openCompleteIper4Modal(request)" class="dropdown-item" type="button"><i class="fa fa-check"></i>Completa Iper 4.0</button>
                                        <button *ngIf="request.FKIDRequestType === 6 && request.Iper4Completed" (click)="openUncompleteIper4Modal(request)" class="dropdown-item" type="button"><i class="fa fa-undo"></i>Annulla completamento Iper 4.0</button>
                                        <button *ngIf="!request.InternalManagement" (click)="openSendReminderModal(request)" class="dropdown-item" type="button"><i class="fa fa-envelope"></i>Invia Sollecito</button>
                                        <a (click)="copyRequestLink(request.user_session.Token)" class="dropdown-item" type="button"><i class="fa fa-link"></i>Link</a>
                                        <a *ngIf="user.FKIDUserRole === 1" [routerLink]="['/richiesta/modifica/' + request.IDRequest]" class="dropdown-item" type="button"><i class="fa fa-pencil"></i>Modifica</a>
                                        <a *ngIf="(user.FKIDUserRole === 2 || user.FKIDUserRole === 3 || user.FKIDUserRole === 4) && request.FKIDRequestType === 5" [routerLink]="['/richiesta/compilazione/' + request.IDRequest]" class="dropdown-item" type="button"><i class="fa fa-pencil"></i>Compila</a>
                                        <button *ngIf="user.FKIDUserRole === 1" (click)="openDeleteRequestModal(request)" class="dropdown-item" type="button"><i class="fa fa-trash-o"></i>Elimina</button>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <ng-template #noLinkedRequests>
                    <div class="detail-empty-state">
                        Nessuna pratica collegata a questo cliente.
                    </div>
                </ng-template>
            </div>
        </div>
    </div>
</div>
